<template>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-else-if="!match">
        <p>Match Does Not Found</p>
    </div>
    <div class="col-12 col-lg-6 content mb-20 mb-lg-0 match-details-crd" v-else>
        <!-- <h1>{{ match.team1.name }} Vs {{ match.team2.name }} Match {{geth1}} </h1> -->
        <div class="card-match-head">
          <div class="match-head-info">
          <span
              class="match-status"
              :class="{
              'badge-match-danger': match.badgeStatus == 'Live',
              'badge-match-success': match.badgeStatus == 'Stumps',
              'badge-match-cancel': match.badgeStatus == 'Cancelled',
              'badge-match-dark': match.badgeStatus == 'Scheduled',
              'badge-match-dark': match.badgeStatus != 'Live' && match.badgeStatus != 'Stumps' && match.badgeStatus != 'Cancelled'
              }"
              >
              {{ match.badgeStatus == 'Live' ? 'Live' : match.status }}
      </span>
      <ul>
          <li v-if="match.badgeStatus == 'Scheduled'">
            {{ match.gmt_datetime | formatDate2 }} | {{ match.gmt_datetime | formatDate('hh:mm A') }}
          </li>
          <li v-else-if="match.comment==''">{{ match.status }}</li>
          <li v-else>{{ match.comment }}</li>
      </ul>
          </div>
          <span class="star-btn">
              <span class="crr-info runrates" v-if="match.runrate && match.badgeStatus != 'Finished'"
                    >CRR : <span class="runrate">{{ match.runrate }}</span></span
              >
              <!-- <i class="ico-star"></i> -->
          </span>
        </div>
        <div class="team-info-wrp card-team-info">
          <span v-if="match.status !='Finished'" class="notification-btn" :class="{ active: $store.getters.isMatchFavourited(match.slug) }" @click="toggleFavourite(match.slug)"><i class="ico-bell"></i></span>
          <ul class="team-info">
              <li :class="{ active: match.winner == 1 }">
                  <span class="team-info-name">
                      <router-link :to="{ name: 'TeamDetails.Players', params:  {  team: match.team1.slug} }">
                          <span class="detail-team-name">{{ match.team1.name }}</span>
                      </router-link>
                      <i v-show="match.badgeStatus == 'Live' && match.batting_team_id == match.team1.id" class="ico-bat"><img :src="$vuePublicPath('/images/bat.svg')" width="19" height="19" alt="bat"></i>
                      <i v-show="match.badgeStatus == 'Live' && match.bowling_team_id == match.team1.id" class="ico-ball"><img :src="$vuePublicPath('/images/cricket_Ball.png')" width="12" height="12" alt="ball"></i>
                  </span>
                  <span class="team-info-score">
                      {{ match.ht_score || '-' }}
                      <span class="over">{{ overs('team1') }}</span>
                  </span>
              </li>
              <li :class="{ active: match.winner == 2 }">
                  <span class="team-info-name">
                      <i v-show="match.badgeStatus == 'Live' && match.batting_team_id == match.team2.id" class="ico-bat"><img :src="$vuePublicPath('/images/bat.svg')" width="19" height="19" alt="bat"></i>
                      <i v-show="match.badgeStatus == 'Live' && match.bowling_team_id == match.team2.id" class="ico-ball"><img :src="$vuePublicPath('/images/cricket_Ball.png')" width="12" height="12" alt="ball"></i>
                      <router-link :to="{ name: 'TeamDetails.Players', params:  {  team: match.team2.slug} }">
                          <span class="detail-team-name">{{ match.team2.name }}</span>
                      </router-link>
                  </span>
                  <span class="team-info-score">
                      {{ match.at_score || '-' }}
                      <span class="over">{{ overs('team2') }}</span>
                  </span>
              </li>
          </ul>
        </div>
    <div class="card-match" :class="match.badgeStatus.toLowerCase()">
    <div class="card-match-body">
        <br>
         <div class="card-match-img"  v-if="match.badgeStatus != 'Scheduled' && match.old_widget == 0">
          <cricket-widget />
            <!-- <iframe width="414" height="262" :src="'https://cricwidget.planetcricket.com/widget.php?match_id='+match.id"></iframe> -->
        </div>
        <div class="card-match-img" v-else>
            <div class="ground-img">
                <img width="600" height="231" class="ground-img" :src="$vuePublicPath('/images/new_ground.jpg').resizeImage(600,231)" alt="Cricket Ground" />
            </div>
            <div class="bowler-img">
                <img
                    width="110" height="142"
                    class="lazyload" :src="getMatchKit(match,'Bowling')"
                    @error="handleImageError"
                    :alt="match.bowling_team_id"
                    />
            </div>
            <div class="batsman-img">
                <img
                    width="152" height="105"
                    class="lazyload" :src="getMatchKit(match,'Batting')"
                    @error="handleImageError"
                    :alt="match.batting_team_id"
                    />
            </div>
            <div class="img-caption" v-if="match.badgeStatus != 'Finished'">
                <div class="img-caption-lft">
                    <div v-if="match.activeBowler">
                        <span class="d-none d-md-block">
                            {{ match.activeBowler.player.name }}
                        </span>
                        <span class="d-block d-md-none">
                            {{ match.activeBowler.player.short_name }}
                        </span>
                        <span class="d-block">
                            {{ match.matchtype == '100 Ball Match'? 'B' : 'Ov' }}: {{ match.activeBowler.overs }} - R: {{ match.activeBowler.score }} - W: {{ match.activeBowler.wickets }}
                        </span>
                    </div>
                </div>
                <div class="img-caption-right">
                    <div>
                        <span class="d-none d-md-block" v-if="match.activeBatsman1 && match.activeBatsman1.player">
                            <i class="ico-bat mr-5" v-if="match.activeBatsman1.active"></i>{{ match.activeBatsman1.player.name }} {{ match.activeBatsman1.score }} ({{ match.activeBatsman1.balls }})
                        </span>
                        <span class="d-block d-md-none" v-if="match.activeBatsman1 && match.activeBatsman1.player">
                            <i class="ico-bat mr-5" v-if="match.activeBatsman1.active"></i>{{ match.activeBatsman1.player.short_name }} {{ match.activeBatsman1.score }} ({{ match.activeBatsman1.balls }})
                        </span>
                        <span class="d-none d-md-block" v-if="match.activeBatsman2 && match.activeBatsman2.player">
                            <i class="ico-bat mr-5" v-if="match.activeBatsman2.active"></i>{{ match.activeBatsman2.player.name }} {{ match.activeBatsman2.score }} ({{ match.activeBatsman2.balls }})
                        </span>
                        <span class="d-block d-md-none" v-if="match.activeBatsman2 && match.activeBatsman2.player">
                            <i class="ico-bat mr-5" v-if="match.activeBatsman2.active"></i>{{ match.activeBatsman2.player.short_name }} {{ match.activeBatsman2.score }} ({{ match.activeBatsman2.balls }})
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="status_div">
            <span class="status">{{ match.comment }}</span>
            <span class="remaning_status" v-if="match.badgeStatus != 'Finished'">
                {{ match.statement }}
            </span>
        </div>
    </div>
</div>
<div class="main-tabs-wrap">
    <ul class="nav main-tabs" role="tablist">
        <li role="tab">
        <router-link
            :to="{ name: 'matchDetail.Scorecard', query: $route.query.match }"
            :class="{ active: $route.name == 'matchDetail.Scorecard' }"
            >
            Scorecard
    </router-link>
    </li>
    <li role="tab">
    <router-link
        :to="{ name: 'matchDetail.Commentary', query: $route.query.match }"
        :class="{ active: $route.name == 'matchDetail.Commentary' }"
        >
        Commentary
</router-link>
</li>
<li role="tab">
<router-link
    :to="{ name: 'matchDetail.Teams', query: $route.query.match }"
    :class="{ active: $route.name == 'matchDetail.Teams' }"
    >
    Teams
</router-link>
</li>
<li role="tab">
<router-link
    :to="{ name: 'matchDetail.MatchInfo', query: $route.query.match }"
    :class="{ active: $route.name == 'matchDetail.MatchInfo' }"
    >
    Info
</router-link>
</li>
<li v-if="match.has_news" role="tab">
<router-link
    :to="{ name: 'matchDetail.News', query: $route.query.match }"
    :class="{ active: $route.name == 'matchDetail.News'}"
    >
    News
</router-link>
</li>
<li v-if="match.has_videos" role="tab">
<router-link
    :to="{ name: 'matchDetail.Videos', query: $route.query.match }"
    :class="{ active: $route.name == 'matchDetail.Videos' }"
    >
    Videos
</router-link>
</li>
</ul>
</div>
<div class="tab-content main-tabs-content">
    <router-view />
</div>
</div>
</template>

<script>
  import cricketWidget from './cricket-widget';
    import moment from 'moment'
    export default {
        name: 'MatchDetail',

        data() {
            return {
                err: '',
                match: null,
                page_title: isBrowser ? document.title : '',
                team: '',
                lastindex :''
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.getDetail()
            }
        },
          computed: {

            geth1() {
                if(this.$route.path.split('/')[3] == "match-info")
                {
                    return ((this.$route.path.split('/')[3]).split('-')[1][0].toUpperCase()+((this.$route.path.split('/')[3]).split('-')[1]).slice(1).toLowerCase()).split('-').join(' ')
                }
                return   this.$route.path.split('/')[3][0].toUpperCase() + this.$route.path.split('/')[3].slice(1).toLowerCase()
            },
        },
        mounted() {
            this.$preload(this.$vuePublicPath('/images/new_ground.jpg').resizeImage(600, 231), ['image']); // for google page speed
            this.getDetail()
            var _this = this;
            this.$root.$on('MatchUpdated', data => {
                if (_this.match && data.match_id == _this.match.id) {
                    _this.getDetail(true)
                }
            });
        },

        beforeDestroy() {
            this.$root.$off('MatchUpdated')
        },

        watch: {
            '$route.params.match'() {
                if(isBrowser)
                    this.getDetail()
            },
            '$route.fullPath'() {
                if(isBrowser)
                this.setTitle()
            }
        },
        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return
            let match = this.match;
            return {
                "@context": "http://schema.org",
                "@type": "SportsEvent",
                "name": match.team1.name + " VS " + match.team2.name,
                "description": match.tournament.name + " - " + match.team1.name + " VS " + match.team2.name + " - " + match.matchno,
                "url": process.env.BASE_URL + "match/" + match.slug + "/teams",
                "eventStatus": "http://schema.org/EventScheduled",
                "eventAttendanceMode": "http://schema.org/OfflineEventAttendanceMode",
                "startDate": moment(match.gmt_datetime).format('YYYY-MM-DD HH:MM'),
                "endDate": moment(match.gmt_datetime).format('YYYY-MM-DD'),
                "image": "https://planetcricket.com/public/images/logo1280x720.png",
                "organizer": {
                    "@type": "Organization",
                    "name": match.tournament.name,
                    "url": process.env.BASE_URL + "tournament/" + match.tournament.slug + "/matches",
                },
                "performer": {
                    "@type": "Thing",
                    "name": match.team1.name + " VS " + match.team2.name,
                },
                "competitor": [
                    {
                        "@type": "SportsTeam",
                        "name": match.team1.name,
                        "image": match.team1.flag
                    },
                    {
                        "@type": "SportsTeam",
                        "name": match.team2.name,
                        "image": match.team2.flag
                    }
                ],
                "location": {
                    "@type": "Place",
                    "name": match.stadium.name + ", " + match.stadium.city + ", " + match.stadium.country,
                    "address": {
                        "@type": "PostalAddress",
                        "name": match.stadium.name + ", " + match.stadium.city + ", " + match.stadium.country,
                    }
                }
            }
        },

        methods: {
            getDetail(cacheBust = false) {
                return this.$axios
                        .get(this.$MATCH_DETAIL_API.replace(':match', this.$route.params.match), {params: {
                            ttl: 0,
                            ...(cacheBust && {cacheBust: Math.ceil(new Date().getTime() / 1000)})
                        }})
                        .then(response => {
                            this.is_data_ready = true
                            this.match = response.data.result.match
                            // console.log(this.match,'mathceeeeeee')
                            isBrowser ? this.setTitle() : '';
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },

            setTitle() {
                if (!this.match || this.match.badgeStatus != 'Live')
                    return ''
                let title =
                        this.match.batting_team_id == this.match.team1_id
                        ? `${this.match.team1.code} ${this.match.ht_score} ${this.overs('team1')}`
                        : `${this.match.team2.code} ${this.match.at_score} ${this.overs('team2')}`
                if (isBrowser) {
                    document.title = title + this.page_title;
                }
                return title + " - ";
            },

            overs(team) {
                if (!this.match[team])
                    return ''
                let innings = this.match.innings.filter(inning => inning.team_id == this.match[team].id)
                return innings.length ? `(${innings[innings.length - 1].overs} ${this.match.matchtype == '100 Ball Match' ? 'balls' : 'Ov'})` : ''
            },

            toggleFavourite(matchSlug) {
                this.$store.commit(this.$store.getters.isMatchFavourited(matchSlug) ? 'removeFavouriteMatch' : 'addFavouriteMatch', matchSlug)
            },
            getMatchKit(match, type) {
                if (type == 'Batting') {
                    return (match.is_test_match) ? 'https://bw.sixlogics.com/cricket/assets/images/team_kits/Batsman.png'.resizeImage(152) : `https://bw.sixlogics.com/cricket/assets/images/team_kits/${match.batting_team_id || match.team1_id}_Batsman.png`.resizeImage(152);
                } else {
                    return (match.is_test_match) ? 'https://bw.sixlogics.com/cricket/assets/images/team_kits/Bowler.png'.resizeImage(110) : `https://bw.sixlogics.com/cricket/assets/images/team_kits/${match.bowling_team_id || match.team2_id}_Bowler.png`.resizeImage(110);
                }

            },

            handleImageError(event) {
                event.target.src = event.target.src.includes('Batsman.png')
                        ? 'https://bw.sixlogics.com/cricket/assets/images/team_kits/Batsman.png'.resizeImage(152)
                        : 'https://bw.sixlogics.com/cricket/assets/images/team_kits/Bowler.png'.resizeImage(110)
            }

        },
        components: {
            cricketWidget
        },
    }
</script>

